var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0747689 11.4704C-0.0249206 11.6698 -0.0249206 11.9688 0.0747689 12.2679C0.174456 12.3676 0.174456 12.4673 0.274146 12.567L9.04673 21.2399C9.44548 21.6386 10.0436 21.6386 10.4424 21.2399C10.8411 20.8411 10.8411 20.243 10.4424 19.8442L3.36449 12.7664L23.0031 12.7664C23.6012 12.7664 24 12.3676 24 11.7695C24 11.1713 23.6012 10.7726 23.0031 10.7726L3.46418 10.7726L10.5421 3.6947C10.9408 3.29595 10.9408 2.69782 10.5421 2.29907C10.3427 2.09969 10.0436 2 9.84424 2C9.64486 2 9.3458 2.09969 9.14642 2.29907L0.373834 11.0716C0.274144 11.1713 0.174457 11.271 0.0747689 11.4704Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0b532258dbf77cd690c5ede2bb5877a5.svg";
export { ForwardRef as ReactComponent };